/*global Modernizr, flatpickr, tns, alert */
/*jslint browser:true, strict:false */

var $autocomplete = ({
	current_input: null,
	timer_id: null,
	delay: 750,
	min_length: 3,
	skip_regexes: [
		new RegExp('^\\s*$')
	],
  rollUp: function (elem, i) {
    if(i > 1) {
      return this.rollUp(elem.parentNode, i-1);
    } else {
      return elem.parentNode;
    }
  },
	each: function (collection) {
		return function (f) {
			for (var i = 0; collection[i]; i++) {
				f(collection[i]);
			}
		};
	},
	serialize: function (form) {
		var field,
			l,
			s = [];

		if (typeof form === 'object' && form.nodeName === "FORM") {
			var len = form.elements.length;

			for (var i = 0; i < len; i++) {
				field = form.elements[i];
				if (field.name && !field.disabled && field.type !== 'button' && field.type !== 'file' && field.type !== 'reset' && field.type !== 'submit') {
					if (field.type === 'select-multiple') {
						l = form.elements[i].options.length;

						for (var j = 0; j < l; j++) {
							if (field.options[j].selected) {
								s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[j].value);
							}
						}
					}
					else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
						s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
					}
				}
			}
		}
		return s.join('&').replace(/%20/g, '+');
	},
	autocomplete: function(q) {
    var autocomplete_container;

    if(q.target.nextElementSibling.classList.contains('autocomplete-results')) {
      autocomplete_container = q.target.nextElementSibling;
    } else {
      autocomplete_container = q.target.parentNode.nextElementSibling;
    }

		if (q.target.value.length < $autocomplete.min_length) {
      autocomplete_container.classList.remove('open');
			return true;
		} else {
      autocomplete_container.classList.add('open');
    }

		for (let i = 0; i < $autocomplete.skip_regexes.length; i++) {
			if ($autocomplete.skip_regexes[i].test(q.target.value)) {
				autocomplete_container.innerHTML = '';
				return true;
			}
		}

		if ($autocomplete.timer_id !== null) {
			window.clearTimeout($autocomplete.timer_id);
		}

		$autocomplete.timer_id = window.setTimeout(
			$autocomplete.do_autocomplete,
			$autocomplete.delay,
			q
		);
	},
	populate_query_input: function(elem) {
    $autocomplete.rollUp(elem, 2).querySelector('input').value = elem.innerText;
		if (elem.classList.contains('ac-artist')) {
			$autocomplete.rollUp(elem, 4).querySelector('[name="query_type"]').value = 'artist';
		} else if (elem.classList.contains('ac-venue')) {
			$autocomplete.rollUp(elem, 4).querySelector('[name="query_type"]').value = 'venue';
		}

    elem.parentNode.classList.remove('open');
	},
	render_query_data: function(data, elem) {
		if (data['artists'].length > 0) {
			data['artists'].forEach(function (row) {
				$autocomplete.rollUp(elem.target, 2).querySelector('.autocomplete-results').innerHTML +=
					'<div class="ac-artist" onclick="window.location.href = \'' + row['content']['url'] + '\';">' +
					row['content']['title'] +
					'</div>';
			});
		}
		if (data['venues'].length > 0) {
			data['venues'].forEach(function (row) {
				$autocomplete.rollUp(elem.target, 2).querySelector('.autocomplete-results').innerHTML +=
					'<div class="ac-venue" onclick="window.location.href = \'' + row['content']['url'] + '\';">' +
					row['content']['title'] +
					'</div>';
			});
		}
	},
	render_city_data: function(data, elem) {
		data['cities'].forEach(function (row) {
			$autocomplete.rollUp(elem.target, 2).querySelector('.autocomplete-results').innerHTML +=
				'<div class="ac-city" onclick="$autocomplete.populate_query_input(this)">' +
				row['city'] + ', ' + row['state'] +
				'</div>' ;
		});
	},
	render_data: function(data, elem) {
		$autocomplete.rollUp(elem.target, 2).querySelector('.autocomplete-results').innerHTML = '';
		if (elem.target.getAttribute('name') === 'query') {
			return $autocomplete.render_query_data(data, elem);
		} else if (elem.target.getAttribute('name') === 'city') {
			return $autocomplete.render_city_data(data, elem);
		}
	},
	do_autocomplete: function(elem) {
		var httpRequest = new XMLHttpRequest();
		httpRequest.onreadystatechange = function (evt) {
			var resp;
			try {
				if (evt.target.readyState === XMLHttpRequest.DONE) {
					if (evt.target.status === 200) {
						resp = JSON.parse(evt.target.responseText);
						if (resp.success === true) {
							$autocomplete.render_data(resp['data'], elem);
						} else {
							alert('Error: ' + resp.message);
						}
					} else {
						alert('Error: ' + resp.message);
					}
				}
			} catch (ex) {
				console.dir(ex);
				alert('Exception: ' + encodeURIComponent(ex.description));
			}
		};
		httpRequest.open('POST', '/autocomplete', true);
		httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		httpRequest.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

		var cookies = document.cookie.split(';');
		for (var i = 0; i < cookies.length; i++) {
			var j = cookies[i].split('=');
			j[0] = j[0].trim();
			if (j[0] === 'csrfToken') {
				httpRequest.setRequestHeader('X-CSRF-Token', j[1]);
				break;
			}
		}

		let ac_form = document.getElementById('autocomplete_data');
		ac_form.querySelector('[name="query"]').value = elem.target.value;
		ac_form.querySelector('[name="query_type"]').value = elem.target.getAttribute('name');
		var data = $autocomplete.serialize(ac_form);
		httpRequest.send(data);
	},
	init: function() {
		var self = this;

    var autocomplete_querys = document.querySelectorAll('.has-autocomplete[data-autocomplete="query"]');
    if(autocomplete_querys) {
      autocomplete_querys.forEach((autocomplete_query) => {
        autocomplete_query.addEventListener('input', self.autocomplete, false);
      });
    }

    var autocomplete_cities = document.querySelectorAll('.has-autocomplete[data-autocomplete="city"]');
    if(autocomplete_cities) {
      autocomplete_cities.forEach((autocomplete_city) => {
        autocomplete_city.addEventListener('input', self.autocomplete, false);
      });
    }

		return this;
	}
}).init();
